<template>
  <div class="container">
    <div class="content">
      <div class="title"><h3>{{title}}</h3><a @click="changeMethod">切换({{inverseTitle}})</a></div>
      <el-form :inline="true" :model="bank" ref="bankForm">
        <div class="searchItem" v-show="isPositive">
        <el-form-item prop="bankCode" :rules="[{
            required: isPositive,
            message: '请选择开户行',
            trigger: 'change'
          }]">
          <select-page
          :value="bank.bankCode"
          option-value="finInstitutionCode"
          option-name="bankName"
          placeholder="请选择银行，支持搜索"
          valueName="bankNameCode"
          remoteKey="bankName"
          @getSelect="setBankName"
          requestUrl="getBankList"
          :request-data="bankListReq"></select-page>
        </el-form-item>
        <el-form-item prop="provinceCode" :rules="[{
            required: isPositive,
            message: '请选择银行网点省份',
            trigger: 'change'
          }]">
          <select-page
              :value="bank.provinceCode"
              :request-data="bankAreaReq"
              placeholder="请选择银行网点省份"
              option-value="areaCode"
              option-name="areaName"
              :pagination="false"
              valueName="bankArea"
              remoteKey="areaName"
              requestUrl="getAreaCode"
              @getSelect="setBankPro"></select-page>
        </el-form-item>
        <el-form-item prop="cityCode" :rules="[{
            required: isPositive,
            message: '请选择银行网点市区',
            trigger: 'change'
          }]">
          <select-page
              style="width:200px;"
              :value="bank.cityCode"
              :request-data="bankCityReq"
              placeholder="请选择银行网点市区"
              option-value="areaCode"
              option-name="areaName"
              :pagination="false"
              valueName="bankCity"
              remoteKey="areaName"
              :begin-init="cityBeginInit"
              @getSelect="setBankCity"
              requestUrl="getAreaCode"></select-page>
        </el-form-item>
        <el-form-item prop="branchCode" :rules="[{
            required: isPositive,
            message: '请选择分行网点',
            trigger: 'change'
          }]">
          <select-page
              :value="bank.branchCode"
              :request-data="branchReq"
              placeholder="请选择分行网点"
              option-value="unionpayCode"
              option-name="branchName"
              valueName="bankBranch"
              remoteKey="branchName"
              :begin-init="branchBeginInit"
              @getSelect="setBankArea"
              label="分行网点"
              requestUrl="getBranch"></select-page>
        </el-form-item>
        </div>
        <div class="searchItem" v-show="!isPositive">
        <el-form-item prop="branchCode" :rules="[{
            required: !isPositive,
            message: '请输入联行号',
            trigger: 'change'
          }]">
          <el-input
              style="width:200px;"
              placeholder="请输入联行号"
              clearable
              v-model="bank.branchCode"
              v-if="!isPositive"
              @input="() => {this.showResult = false}">
            </el-input>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="onSubmit" :loading="searchLoading">查询</el-button>
        </el-form-item>
        </el-form>
      <div class="result" v-show="showResult">
        <h4>结果</h4>
        <div class="resultItem"><span class="label">开户行</span>{{bank.bankResult}}</div>
        <div class="resultItem" v-if="bank.provinceResult"><span class="label">省份</span>{{bank.provinceResult}}</div>
        <div class="resultItem" v-if="bank.cityResult"><span class="label">市区</span>{{bank.cityResult}}</div>
        <div class="resultItem"><span class="label">分行</span>{{bank.branchResult}}</div>
        <div class="resultItem"><span class="label">联行号</span>{{bank.branchCode}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { getBranchByCode } from '@/api/global'
import { parseTime } from '@/utils/formatTime'
import selectPage from '@/components/selectPage'
export default {
  components: {
    selectPage: selectPage
  },
  data () {
    return {
      isPositive: true, // true: 通过行业分类查询mcc false: 根据mcc查询行业分类
      title: '根据银行查询联行号',
      inverseTitle: '根据联行号查询银行',
      bankList: [],
      provinceList: [],
      cityList: [],
      branchList: [],
      showResult: false,
      bank: {
        bankCode: '',
        provinceCode: '',
        cityCode: '',
        branchCode: '',
        bankResult: '',
        provinceResult: '',
        cityResult: '',
        branchResult: ''
      },
      searchLoading: false,
      bankAreaReq: {
        areaLevel: 1
      }, // 银行网点省的请求数据
      bankListReq: {
        bankName: ''
      }// 银行列表请求数据，本来可以为空对象，但是为了获取初始列表
    }
  },
  methods: {
    changeMethod () {
      [this.title, this.inverseTitle] = [this.inverseTitle, this.title]
      this.showResult = false
      this.isPositive = !this.isPositive
    },
    changeBranchCode () {
      this.showResult = false
      this.$nextTick(() => {
        this.bank.branchResult = this.$refs.branchCode.selectedLabel
      })
    },
    onSubmit () {
      this.$refs.bankForm.validate((valid) => {
        if (valid) {
          if (this.isPositive) {
            this.showResult = true
          } else {
            this.searchLoading = true
            const date = parseTime(new Date(), '{yy}{mm}{dd}{hh}{ii}')
            const params = qs.stringify({
              agentId: date,
              reqSerialNo: date,
              data: JSON.stringify({ unionpayCode: this.bank.branchCode })
            })
            getBranchByCode(params).then((res) => {
              this.searchLoading = false
              if (res.data.total) {
                const data = res.data.list[0]
                this.bank.bankResult = data.bankName
                this.bank.provinceResult = data.cftProvinceName
                this.bank.cityResult = data.cftCityName
                this.bank.branchResult = data.branchName
                this.showResult = true
              } else {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: '联行号有误，无法查询对应银行信息'
                })
              }
            })
          }
        }
      })
    },
    // 设置银行名称
    setBankName (result) {
      this.showResult = false
      if (result) {
        this.bank.bankResult = result.name
        this.bank.bankCode = result.value
      }
      this.bank.provinceCode = ''
      this.bank.cityCode = ''
      this.bank.branchCode = ''
      this.bank.provinceResult = ''
      this.bank.cityResult = ''
      this.bank.branchResult = ''
    },
    // 设置省
    setBankPro (result) {
      this.showResult = false
      if (result) {
        this.bank.provinceResult = result.name
        this.bank.provinceCode = result.value
      }
      this.bank.cityResult = ''
      this.bank.cityCode = ''
      this.bank.branchResult = ''
      this.bank.branchCode = ''
    },
    // 设置市
    setBankCity (result) {
      this.showResult = false
      if (result) {
        this.bank.cityResult = result.name
        this.bank.cityCode = result.value
        if (this.bank.cityCode && !this.bank.bankResult) {
          this.$message({
            message: '请先选择开户行！',
            type: 'warning'
          })
        }
      }
      this.bank.branchResult = ''
      this.bank.branchCode = ''
    },
    /**
             * 选择银行支行
             */
    setBankArea (result) {
      this.showResult = false
      if (result) {
        this.bank.branchResult = result.name
        this.bank.branchCode = result.value
      }
    }
  },
  computed: {
    // 加载城市列表的请求数据
    bankCityReq () {
      if (this.bank.provinceCode) {
        return {
          areaLevel: 2,
          parentCode: this.bank.provinceCode
        }
      } else {
        return {}
      }
    },
    // 是否开始加载市列表
    cityBeginInit () {
      if (JSON.stringify(this.bankCityReq) !== '{}') {
        return true
      } else {
        return false
      }
    },
    // 加载分支列表的请求数据
    branchReq () {
      if (this.bank.bankCode && this.bank.bankCode && this.bank.provinceCode && this.bank.cityCode) {
        return {
          finInstitutionCode: this.bank.bankCode,
          cftAreaCode: this.bank.provinceCode,
          cftCityCode: this.bank.cityCode
        }
      } else {
        return {}
      }
    },
    // 是否开始加载分支列表
    branchBeginInit () {
      if (JSON.stringify(this.branchReq) !== '{}') {
        return true
      } else {
        return false
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    background-color: #f0f2f5;
    .content{
      width:1000px;
      height:100%;
      overflow-y: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      border-radius: 11px;
      background:rgba(255,255,255,1);
      padding: 30px;
      .title {
        margin-bottom: 30px;
        h3 {
          display: inline-block;
          margin-right: 30px;
        }
        a {
          color: #1482f0;
        }
      }
      .searchItem {
        display: inline-block;
      }
      .result {
        margin-top: 50px;
        .resultItem {
          margin-top: 15px;
        }
        .label {
          display: inline-block;
          width: 100px;
          margin-right: 10px;
        }
      }
    }
  }
</style>
